import axios from 'axios';  

export function requestUserData(uid: number) {
    const baseURL = "https://users.askslim.org/svc/users?uid=" + uid.toString();
    return axios({
        method: 'get', 
        url: baseURL
    }).then((response) => {
        const data = response.data; 
        if (response.status === 200) {
            return {
                data: data
            }
        }
    }).catch((error) => {
        return {
            data: {error: error}
        }
    })
}